import SwalMessage from "../domain/message/SwalMessage";

const isColaborador = ({ next, router, to, store }) => {
  let { tipo } = store.state.usuario;

  if ([3, 6, 11, 13].includes(tipo)) {
    return next();
  }

  SwalMessage.warningMessage(
    `<p>Página não está disponível para seu usuário.</p>`,
    "Ops!"
  );

  setTimeout(() => {
    return router.push(`/`);
  }, 3500);
};

export default isColaborador;



// WEBPACK FOOTER //
// ./src/middleware/isColaborador.js